module.exports = __webpack_public_path__ + "img/_Clover.593ca6a4.png";